export default __webpack_public_path__ + "static/media/provisional.8c6ee87f.svg";